import React, { Component } from 'react'
import { render } from 'react-dom'
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';
import Graph from './graph'
import '../../App.css'
import {
  Container,
  Header,
} from 'semantic-ui-react'


import {
  GetKatexGeometricFunctionName,
  cumulative_cut_list_threshold,
  geometric_delta,
  geometric_p_init,
  geometric_max_plot,
  get_cumulative_list,
  get_geometric_arg_list,
  get_geometric_list,
} from '../../util/statistics'

import { MDBContainer, MDBAlert } from 'mdbreact';

class geometric extends Component {

  constructor(props) {
    super(props);

    this.state = {
      p: geometric_p_init,
      p_range_check: true,
      ageometric: get_geometric_arg_list(geometric_p_init).map(a => Number(a.toFixed(3))),
      vgeometric: get_geometric_list(geometric_p_init).map(a => Number(a.toFixed(3))),
      cgeometric: get_cumulative_list(get_geometric_list(geometric_p_init), geometric_delta).map(a => Number(a.toFixed(3))),
    };
  }

  onGeometricPChangeHandler = (event) => {
    if (event.target.value != "") {
      var p = event.target.value
      var is_p_check = false
      if (0 < p && p < 1) {
        var is_p_check = true
      }
      this.setState({ 
        p: event.target.value,
        p_range_check: is_p_check,
        ageometric: get_geometric_arg_list(event.target.value).map(a => Number(a.toFixed(3))),
        vgeometric: get_geometric_list(event.target.value).map(a => Number(a.toFixed(3))),
        cgeometric: get_cumulative_list(get_geometric_list(event.target.value), geometric_delta).map(a => Number(a.toFixed(3))),
      });
    } else {
      this.setState({ 
        p: geometric_p_init,
        p_range_check: true,
        ageometric: get_geometric_arg_list(geometric_p_init).map(a => Number(a.toFixed(3))),
        vgeometric: get_geometric_list(geometric_p_init).map(a => Number(a.toFixed(3))),
        cgeometric: get_cumulative_list(get_geometric_list(geometric_p_init), geometric_delta).map(a => Number(a.toFixed(3))),
      });
    }
  }


  render() {

    var list = []
    if(this.state.p != "") {
      if(this.state.vgeometric.length != 0) {
        for(var i = 0; i < this.state.cgeometric.length; i++){
          list.push(
            <tr>
              <td className="td_01">{this.state.ageometric[i]}</td>
              <td className="td_01">{this.state.p}</td>
              <td className="td_01">{(100 * this.state.vgeometric[i]).toFixed(2)} % </td>
              <td className="td_01">{(100 * this.state.cgeometric[i]).toFixed(2)} % </td>
            </tr>
          )
          if(this.state.cgeometric[i] > 0.999) {
            break;
          }
        }
      }
    }

    var geometric_data = [];
    if(this.state.k != "") {
      if(this.state.vgeometric.length != 0) {
        for(var i = 0; i < this.state.cgeometric.length; i++){
          geometric_data.push({
            name: this.state.ageometric[i],
            pdf: this.state.vgeometric[i],
            cdf: this.state.cgeometric[i],
          })

          if(this.state.cgeometric[i] > cumulative_cut_list_threshold) {
            break;
          }
        }
      }
    }

    return (
      <div className="base">
      
        <Header as='h1'>幾何分布 </Header>

        <GetKatexGeometricFunctionName />

        <div style={{ textAlign: 'center' }}>
          <div>
            <Header as='h1'>
            input : <InlineMath>{`\\displaystyle p `}</InlineMath>
            <input onChange={this.onGeometricPChangeHandler} style={{"margin-left":"20px"}}/>
            </Header>
          </div>
        </div>


        <MDBContainer style={{
            "width":"70%",
            "margin-left":"auto",
            "margin-right":"auto",
            "margin-top":"20px",
            "text-align":"center"
          }}>

      { ! this.state.p_range_check &&  
          <MDBAlert color="danger" >
            <p>  <InlineMath>{`\\displaystyle p `}</InlineMath> should be from 0 to 1.</p>
          </MDBAlert>
      }

      {/*
          <MDBAlert color="secondary" >
            A simple secondary alert—check it out!
          </MDBAlert>
          <MDBAlert color="success" >
            A simple success alert—check it out!
          </MDBAlert>
          <MDBAlert color="danger" >
            A simple success alert—check it out!
          </MDBAlert>
          <MDBAlert color="warning" >
            A simple warning alert—check it out!
          </MDBAlert>
          <MDBAlert color="info" >
            A simple info alert—check it out!
          </MDBAlert>
          <MDBAlert color="light" >
            A simple light alert—check it out!
          </MDBAlert>
          <MDBAlert color="dark" >
            A simple dark alert—check it out!
          </MDBAlert>
      */}
        </MDBContainer>

        <Graph data={geometric_data}/>
        
        <table border="1" className="table_base">
            <tr>
              <th className="th_01"><InlineMath>{`\\displaystyle k `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle p `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle P \\left(k | p \\right)`}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle \\sum_{k'} P \\left(k' | p \\right) `}</InlineMath></th>
            </tr>
              {list}
        </table>

      </div>
    )   
  }
}

export default geometric;
